import React from "react";
import aboutImg from "../../assets/images/servicePageImg1.png";
import PrimaryButton from "../common/PrimaryButton";

const Services = () => {
  return (
    <div className="py-6 sm:py-20 mx-4 sm:mx-12 flex flex-col md:flex-row gap-5 sm:gap-10 justify-center items-center">
      <div className="flex flex-col sm:flex-row gap-4 items-center sm:items-end flex-wrap">
        <div className="flex flex-col gap-4 max-w-lg">
          <h3 className="jost-regular text-xl sm:text-2xl text-primary py-4 uppercase">
            OUR services
          </h3>

          <h1 className="jost-regular text-3xl sm:text-5xl max-w-xl">
            Empowering lessons to overcome stress and build resilience.
          </h1>
          <p className="max-w-2xl opacity-50">
            At Psyche Ethos, we offer transformative lessons designed to help
            individuals navigate mental stress. Our services focus on building
            resilience, fostering emotional clarity, and unlocking your inner
            strength. Let us guide you on a journey toward lasting well-being
            and mental peace.
          </p>
          <PrimaryButton
            onClick={() => {
              window.scrollTo(0, 1500);
            }}
            className="w-[210px] uppercase mt-4 sm:mt-6"
            icon
          >
            Learn more
          </PrimaryButton>
        </div>
        <div>
          <img src={aboutImg} className="max-w-[200px]" alt="" />
        </div>
        <div className="max-w-lg">
          <h1 className="jost-regular text-2xl sm:text-4xl max-w-xl mb-4">
            Your health, your choice
          </h1>
          <p className="max-w-2xl opacity-50">
            Your mental wellbeing and peace of mind is in your hands, choice
            wisely!
          </p>
          <div className="max-w-[460px] mt-4 text-black text-opacity-50">
            <div className="flex flex-col gap-4">
              <div>
                <div className="w-full flex justify-between">
                  <p>Improved well-being</p>
                  <p>91%</p>
                </div>
                <div className="h-4 w-full px-1 mt-2 flex justify-start items-center bg-[#D9D9D9] rounded-lg">
                  <div className="h-2 bg-secondary w-[91%] rounded-lg"></div>
                </div>
              </div>
              <div>
                <div className="w-full flex justify-between">
                  <p>Communication Skills</p>
                  <p>88%</p>
                </div>
                <div className="h-4 w-full px-1 mt-2 flex justify-start items-center bg-[#D9D9D9] rounded-lg">
                  <div className="h-2 bg-secondary w-[88%] rounded-lg"></div>
                </div>
              </div>
              <div>
                <div className="w-full flex justify-between">
                  <p>Health Counslor</p>
                  <p>89%</p>
                </div>
                <div className="h-4 w-full px-1 mt-2 flex justify-start items-center bg-[#D9D9D9] rounded-lg">
                  <div className="h-2 bg-secondary w-[89%] rounded-lg"></div>
                </div>
              </div>

              <div>
                <div className="w-full flex justify-between">
                  <p>Expert Team</p>
                  <p>95%</p>
                </div>
                <div className="h-4 w-full px-1 mt-2 flex justify-start items-center bg-[#D9D9D9] rounded-lg">
                  <div className="h-2 bg-secondary w-[95%] rounded-lg"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
